import { TFreightCard, TTruckerItem } from 'context/reducers/truckers.type';

export const mockedDataSuggested: TTruckerItem[] = [
  {
    vehicle: {
      id: 'LeKWZ',
      plate: 'KOF-1997',
      name: '',
      type: 3,
      ownerType: 1,
      bodyName: 'Ba\u00fa',
      typeName: 'Carreta LS',
    },
    person: {
      id: '6VM',
      uuid: '969cac15-8340-4755-af87-ce677be98407',
      selfieUri: '',
      name: 'Bowser figueiredo',
      verified: true,
      isVip: true,
      areaCodes: [11],
      whereIs: 'Ribeirão Preto, SP',
    },
    lastLocation: {
      verified: true,
      date: '2023-01-30 07:38:23',
      coordinate: {
        lat: -11.6946635,
        lng: -55.4573505,
      },
      distance: 18,
    },
    checkin: {
      createdAt: '2023-01-24 14:41:21',
      originCity: 'S\u00e3o Paulo',
      destination: 'Rio de Janeiro',
      originState: 'S\u00e3o Paulo',
    },
    tag: 0,
    hasPermission: false,
  },
  {
    vehicle: {
      id: 'PKVvW',
      plate: 'FLK-7715',
      name: '',
      type: 2,
      ownerType: 2,
      bodyName: 'Ba\u00fa',
      typeName: 'Carreta',
    },
    person: {
      id: '0wN',
      uuid: '969b1467-f211-448f-b68f-15fb68595d61',
      selfieUri: '',
      name: 'Mario Santos',
      verified: false,
      isVip: true,
      areaCodes: [15],
      whereIs: null,
    },
    lastLocation: {
      verified: true,
      date: '2023-01-30 05:38:23',
      coordinate: {
        lat: 0,
        lng: 0,
      },
      distance: 8,
    },
    checkin: {
      createdAt: '2023-01-24 14:41:20',
      originCity: 'S\u00e3o Paulo',
      destination: '',
      originState: 'S\u00e3o Paulo',
    },
    tag: 0,
    hasPermission: false,
  },
  {
    vehicle: {
      id: 'q3gmA',
      plate: 'ABE-2727',
      name: '',
      type: 4,
      ownerType: 2,
      bodyName: 'Ba\u00fa',
      typeName: 'Bitrem',
    },
    person: {
      id: '63j',
      uuid: '96ad13a3-8a40-4a08-a84f-ac50d86332c4',
      selfieUri: '',
      name: 'Luigi Santos',
      verified: false,
      isVip: false,
      areaCodes: [19],
      whereIs: null,
    },
    lastLocation: {
      verified: true,
      date: '2023-01-30 04:38:23',
      coordinate: {
        lat: 0,
        lng: 0,
      },
      distance: 3,
    },
    checkin: {
      createdAt: '2023-01-24 14:41:19',
      originCity: 'S\u00e3o Paulo',
      destination: '',
      originState: 'S\u00e3o Paulo',
    },
    tag: 0,
    hasPermission: true,
  },
];

export const mockedMetaSuggested: TFreightCard = {
  pagination: { next: 2, page: 1, previous: null, total: 2, reachedEnd: true },
  cachedAt: '',
  freight: {
    code: 'SPRJ-80F8',
    tag: 'frete/testetech-nca-1/carga-de-sao-paulo-sp-para-rio-de-janeiro-rj/veiculo-fiorino,vlc,34,toco,truck,bitruck,carreta,carreta-ls,vanderleia,bitrem,rodotrem/especie-big-bag/carga-test/2259716624196/',
    score: {
      unlocked: false,
    },
    origin: {
      city: 'S\u00e3o Paulo',
      federativeUnit: 'SP',
    },
    destination: {
      city: 'Rio de Janeiro',
      federativeUnit: 'RJ',
    },
    vehicleTypes: [
      {
        category: 'leve',
        types: [
          {
            id: 20,
            name: 'Fiorino',
          },
          {
            id: 18,
            name: 'VLC',
          },
          {
            id: 7,
            name: '3/4',
          },
          {
            id: 11,
            name: 'Toco',
          },
        ],
      },
      {
        category: 'medio',
        types: [
          {
            id: 1,
            name: 'Truck',
          },
          {
            id: 15,
            name: 'Bitruck',
          },
        ],
      },
      {
        category: 'pesado',
        types: [
          {
            id: 2,
            name: 'Carreta',
          },
          {
            id: 3,
            name: 'Carreta LS',
          },
          {
            id: 19,
            name: 'Vanderl\u00e9ia',
          },
          {
            id: 4,
            name: 'Bitrem',
          },
          {
            id: 5,
            name: 'Rodotrem',
          },
        ],
      },
    ],
  },
  areaCodes: [
    {
      areaCode: 11,
      text: 'S\u00e3o Paulo \u2013 SP',
    },
    {
      areaCode: 15,
      text: 'Sorocaba \u2013 SP',
    },
    {
      areaCode: 19,
      text: 'Campinas \u2013 SP',
    },
    {
      areaCode: 34,
      text: 'Uberl\u00e2ndia \u2013 MG',
    },
    {
      areaCode: 71,
      text: 'Salvador \u2013 BA',
    },
  ],
  extrasTruckers: {
    hasConsumed: false,
    maxLimitView: 15,
    consumption: {
      consumed: 0,
      freeAvailable: 5,
      freeLimit: 5,
    },
  },
};
